import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["dropdownFilterable"];

  removeOptionsPreviouslySelected() {
    const valuesAlreadyUsed = this.getOptionsAlreadyChecked();
    const targetDropdown = this.dropdownFilterableTargets.slice(-1)[0];

    // loop backwards to avoid messing with the indexes
    for (let i = targetDropdown.options.length - 1; i >= 0; i--) {
      if (valuesAlreadyUsed.includes(targetDropdown.options[i].value)) {
        targetDropdown.options[i].remove();
      }
    }
  }

  getOptionsAlreadyChecked() {
    // when we call this function we already have created the dropdown that we
    // need to filter the options. So, we have to remove it and consider only
    // the chosen options by the previous dropdowns
    const dropdownsWithOptionsSelected = this.dropdownFilterableTargets.slice(0, -1);

    return dropdownsWithOptionsSelected.map((dropdown) => {
      const indexSelected = dropdown.options.selectedIndex;
      return dropdown.options[indexSelected].value;
    });
  }
}
